export var HTTP_METHODS;
(function (HTTP_METHODS) {
    HTTP_METHODS["GET"] = "GET";
    HTTP_METHODS["DELETE"] = "DELETE";
    HTTP_METHODS["PUT"] = "PUT";
    HTTP_METHODS["POST"] = "POST";
    HTTP_METHODS["PATCH"] = "PATCH";
})(HTTP_METHODS || (HTTP_METHODS = {}));
export class GenericAPI {
    constructor(baseUrl = '', getHeadersCb = () => ({}), credentials = 'same-origin') {
        this.baseUrl = baseUrl;
        this.getHeadersCb = getHeadersCb;
        this.credentials = credentials;
    }
    get(path) {
        return this.callApi(path, undefined, HTTP_METHODS.GET);
    }
    delete(path, body) {
        return this.callApi(path, body, HTTP_METHODS.DELETE);
    }
    put(path, body) {
        return this.callApi(path, body, HTTP_METHODS.PUT);
    }
    post(path, body) {
        return this.callApi(path, body, HTTP_METHODS.POST);
    }
    patch(path, body) {
        return this.callApi(path, body, HTTP_METHODS.PATCH);
    }
    callApi(path, body, method = HTTP_METHODS.GET) {
        return new Promise((resolve, reject) => {
            fetch(`${this.baseUrl}${path}`, {
                method,
                headers: Object.assign({}, this.getHeadersCb()),
                body: Object.is(body, undefined) ? null : JSON.stringify(body),
                credentials: this.credentials,
            })
                .then(async (response) => {
                let result = await response.text();
                try {
                    result = JSON.parse(result);
                }
                catch (e) {
                    // not needed
                }
                if (!response.ok) {
                    reject(new GenericApiError(response.status, result, path, this.baseUrl, method, response));
                }
                resolve(result);
            })
                .catch(e => {
                throw e;
            });
        });
    }
}
export class GenericApiError extends Error {
    constructor(status, payload, path, baseUrl, method, response) {
        super(getError(status, path, baseUrl, method, payload, response));
        this.status = status;
        this.payload = payload;
    }
}
const getError = (status, path, baseUrl, method, payload, response) => {
    switch (status) {
        case 404:
            return `404 Not found ${method} ${baseUrl}${path}`;
        default:
            return `Request failed ${status} ${baseUrl}${path} ${JSON.stringify(payload)} ${method} ${JSON.stringify(response)}`;
    }
};
export const getAmbassadorHeaders = (instance) => ({
    authorization: instance,
});
//# sourceMappingURL=generic.js.map